import { Row, Col } from 'react-bootstrap';
import SelectInput from '../SelectInput';
import TextInput from '../TextInput';
import states from './constants';
// import countries from './constantsCountries';

import { ManualAddressInputProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ManualAddressInput = (props: ManualAddressInputProps & any) => {
    const {
        name,
        ...rest
    } = props;
    return (
        <>
            <TextInput
                key={`${name}.line1`}
                name={`${name}.line1`}
                label='Address line 1'
                {...rest}
            />
            <TextInput
                key={`${name}.line2`}
                name={`${name}.line2`}
                label='Address line 2'
                {...rest}
            />
            <TextInput
                key={`${name}.line3`}
                name={`${name}.line3`}
                label='Address line 3 (optional)'
                {...rest}
            />
            <TextInput
                key={`${name}.suburb`}
                name={`${name}.suburb`}
                label='Suburb'
                // inlineHelp='Outside Australia enter City or Town'
                {...rest}
            />
            <Row>
                <Col md={6}>
                    {/* TO DO
                    // Show Australia State drop down OR International Province/Region text input */}
                    <SelectInput<string>
                        key={`${name}.state`}
                        name={`${name}.state`}
                        label='State'
                        options={states}
                        // inlineHelp='Select an Australian state or territory'
                        addBlank
                        {...rest}
                    />
                    {/* TO DO
                    //  Show International Province/Region text input */}
                    {/* <TextInput
                        key={`${name}.state`}
                        name={`${name}.state`}
                        label='State'
                        inlineHelp='Outside Australia enter province or region'
                        {...rest}
                    /> */}
                </Col>
                <Col md={6}>
                    <TextInput
                        key={`${name}.postcode`}
                        name={`${name}.postcode`}
                        label='Postcode'
                        // inlineHelp='Or ZIP code'
                        {...rest}
                    />
                </Col>
            </Row>
            {/* <SelectInput<string>
                key={`${name}.country`}
                name={`${name}.country`}
                label='Country'
                options={countries}
                {...rest}
            /> */}
        </>
    );
};

export default ManualAddressInput;
